import React, { useState } from 'react';
import {
  TableCell,
  TableRow,
  IconButton,
  Collapse,
  Box,
  Table,
  TableBody,
  Tooltip,
  TableHead,
  Badge,
} from '@mui/material';
import moment from 'moment';

import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import FactoryIcon from '@mui/icons-material/Factory';
export default function Row(props) {
  const {
    ordem,
    abrirModalDefineVeiculo,
    confirmaCargaVeiculo,
    removeCargaVeiculo,
  } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow>
        <TableCell colSpan={2} sx={{ width: '12%' }}>
          <IconButton onClick={() => setOpen(!open)}>
            {open ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
          </IconButton>

          {ordem.codVeiculo === 0 ? (
            <Tooltip title="Selecionar Caminhao para a entrega ">
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() =>
                  abrirModalDefineVeiculo(ordem.venda, ordem.qtdeProntos)
                }
              >
                <LocalShippingIcon sx={{ color: 'primary.main' }} />
              </IconButton>
            </Tooltip>
          ) : (
            <>
              <Tooltip title="Remover pedido da carga ">
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() =>
                    removeCargaVeiculo(ordem.venda, ordem.codVeiculo)
                  }
                >
                  <ClearIcon sx={{ color: 'primary.error' }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Confirmar pedido na carga  ">
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() =>
                    confirmaCargaVeiculo(ordem.venda, ordem.codVeiculo)
                  }
                >
                  <CheckIcon sx={{ color: 'primary.success' }} />
                </IconButton>
              </Tooltip>
            </>
          )}
          <Badge
            badgeContent={ordem.prioridade}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            overlap="circular"
            color={
              ordem.prioridade === 1
                ? 'error'
                : ordem.prioridade === 2
                ? 'warning'
                : ordem.prioridade === 3
                ? 'success'
                : ordem.prioridade === 4
                ? 'info'
                : ordem.prioridade === 5
                ? 'primary'
                : 'primary'
            }
          >
            <FactoryIcon color="primary" />
          </Badge>
        </TableCell>
        <TableCell>{ordem.venda}</TableCell>
        <TableCell>
          {moment(ordem.opr_emissao).add(3, 'h').format('DD/MM/YY')}
        </TableCell>
        <TableCell>
          {moment(ordem.opr_entrega).add(3, 'h').format('DD/MM/YY')}
        </TableCell>
        <TableCell>{ordem.fantasia ? ordem.fantasia : ordem.razao}</TableCell>
        <TableCell>{ordem.cidade}</TableCell>
        <TableCell>{ordem.qtdePedidos}</TableCell>
        <TableCell>{ordem.qtdeProntos}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow
                    sx={{
                      borderRadius: '5px',
                      color: 'primary.textColor',
                    }}
                  >
                    <TableCell
                      sx={{
                        bgcolor: 'primary.main',
                        border: 'solid 1px primary.warning',
                        borderRadius: '15px',
                        color: 'primary.textColor',
                      }}
                    >
                      <strong>CAIXA </strong>
                    </TableCell>

                    <TableCell
                      sx={{
                        bgcolor: 'primary.main',
                        border: 'solid 1px primary.warning',
                        borderRadius: '15px',
                        color: 'primary.textColor',
                      }}
                    >
                      <strong>COMP. </strong>
                    </TableCell>
                    <TableCell
                      sx={{
                        bgcolor: 'primary.main',
                        border: 'solid 1px primary.warning',
                        borderRadius: '15px',
                        color: 'primary.textColor',
                      }}
                    >
                      <strong>LARG. </strong>
                    </TableCell>
                    <TableCell
                      sx={{
                        bgcolor: 'primary.main',
                        border: 'solid 1px primary.warning',
                        borderRadius: '15px',

                        color: 'primary.textColor',
                      }}
                    >
                      <strong>ALT. </strong>
                    </TableCell>
                    <TableCell
                      sx={{
                        bgcolor: 'primary.main',
                        border: 'solid 1px primary.warning',
                        borderRadius: '15px',
                        color: 'primary.textColor',
                      }}
                    >
                      <strong>GRAM. </strong>
                    </TableCell>

                    <TableCell
                      sx={{
                        bgcolor: 'primary.main',
                        border: 'solid 1px primary.warning',
                        borderRadius: '15px',
                        color: 'primary.textColor',
                      }}
                    >
                      <strong>QTDE </strong>
                    </TableCell>
                    <TableCell
                      sx={{
                        bgcolor: 'primary.main',
                        border: 'solid 1px primary.warning',

                        color: 'primary.textColor',
                        borderRadius: '15px',
                      }}
                    >
                      <strong> VOLUMES</strong>
                    </TableCell>
                    <TableCell
                      sx={{
                        bgcolor: 'primary.main',
                        border: 'solid 1px primary.warning',

                        color: 'primary.textColor',
                        borderRadius: '15px',
                      }}
                    >
                      <strong> PALETES</strong>
                    </TableCell>
                    <TableCell
                      sx={{
                        bgcolor: 'primary.main',
                        border: 'solid 1px primary.warning',

                        color: 'primary.textColor',
                        borderRadius: '15px',
                      }}
                    >
                      <strong>STATUS </strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {ordem.itens ? (
                    ordem.itens.map((item, index) => (
                      <TableRow
                        key={(item, index)}
                        sx={
                          item.status === 'FINALIZADO'
                            ? {
                                bgcolor: 'primary.infoRow',
                              }
                            : { bgcolor: '' }
                        }
                      >
                        <TableCell>
                          <strong>{item.caixa}</strong>
                        </TableCell>

                        <TableCell>{item.comprimento}</TableCell>
                        <TableCell>{item.largura}</TableCell>
                        <TableCell>{item.altura}</TableCell>
                        <TableCell>{item.gramatura}</TableCell>
                        <TableCell>{item.quantidade}</TableCell>
                        <TableCell>{item.volume}</TableCell>
                        <TableCell>{item.palete}</TableCell>
                        <TableCell>
                          <strong>{item.status}</strong>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <></>
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
